import { render, staticRenderFns } from "./CourseMaterialPage.vue?vue&type=template&id=4414efba"
import script from "./CourseMaterialPage.vue?vue&type=script&lang=js"
export * from "./CourseMaterialPage.vue?vue&type=script&lang=js"
import style0 from "./CourseMaterialPage.vue?vue&type=style&index=0&id=4414efba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports